<template>
    <div class="record">
        <csp-record-header v-if="!isLoading" :can-upload-files="permissions.canUploadFiles"
            :record-id="recordId">
            <b-row v-if="isLoading" no-gutters>
                <b-col class="record-header-left" cols="9">
                    <div>
                        <span class="font-weight-bold"/>
                        <span/>
                    </div>
                    <div>
                        <span class="font-weight-bold"/>
                        <span/>
                    </div>
                </b-col>
                <b-col class="record-header-right" cols="3">
                    <div class="referenceNumber font-weight-bold"/>
                    <div class="status-bar"/>
                </b-col>
            </b-row>
            <b-row v-if="!isLoading" no-gutters>
                <b-col class="record-header-left" cols="9">
                    <div>
                        <span class="font-weight-bold">{{ customer.attributes.fullNameWithRepresentative }}</span>
                        <span>
                            <span v-if="customer.attributes.customerNumber">
                                ({{ customer.attributes.customerNumber }})
                            </span>
                            <span v-if="hasCustomerDataForDisplay">
                                -
                            </span>
                            {{ firm.attributes.name }}
                            <span v-if="firm.attributes.nameAffix">({{ firm.attributes.nameAffix }})</span>
                        </span>
                    </div>
                    <div>
                        <span class="font-weight-bold">{{ vehicle.attributes.licensePlate }}</span>
                        <span>({{ claimTypeLabel }})</span>
                    </div>
                </b-col>
                <b-col class="record-header-right" cols="3">
                    <div class="referenceNumber font-weight-bold">
                        <csp-text-with-tooltip
                            v-if="furtherReferencNumbersText"
                            :text="referenceNumber"
                            :tooltip="furtherReferencNumbersText"/>
                        <span v-else>{{ referenceNumber }}</span>
                    </div>
                    <div class="status-bar">
                        <b-button
                            v-if="permissions?.canDeleteRecord === true"
                            class="record-delete-button"
                            size="sm"
                            title="Schadenakte löschen"
                            variant="secondary"
                            @click="deleteRecord">
                            <i class="inticon-trash"/>
                        </b-button>

                        <csp-record-state-overview :state-data-items="stateDataItems"/>

                        <csp-record-state-change
                            v-if="permissions.canChangeState"
                            :can-create-regress-claim="permissions.canCreateRegressClaim"
                            :can-select-order-scope="permissions.canSelectOrderScope"
                            :record-id="recordId"
                            :record-state="state"
                            @reload-state-recommended="handleReloadStateRecommended"
                            @state-changed="reloadWindow"/>
                    </div>
                </b-col>
            </b-row>
        </csp-record-header>
        <router-view v-show="!isLoading"/>
        <div v-if="isLoading" class="d-flex justify-content-center py-5 mb-0">
            <csp-loading-indicator/>
        </div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div id="tabs" ref="tabs" v-html="tabsContent"/>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import TextWithTooltip from '@desktop/components/TextWithTooltip.vue';

    const container = Container.getInstance()
    const recordRepository = container.getDesktopRecordRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'Record',
        components: {
            'csp-text-with-tooltip': TextWithTooltip,
        },
        data() {
            return {
                tabsContent: '',
                isLoading: true,
                recordId: this.$root.contextData.recordId,
                state: null,
                vehicle: null,
                firm: null,
                customer: null,
                claimTypeLabel: null,
                permissions: null,
                referenceNumber: null,
                referenceNumberLawyer: null,
                referenceNumberDamageServiceProvider: null,
            };
        },
        computed: {
            furtherReferencNumbersText() {
                if (!this.referenceNumberLawyer && !this.referenceNumberDamageServiceProvider) {
                    return null;
                }
                return [
                    this.referenceNumberLawyer ? `AZ RA: ${this.referenceNumberLawyer}` : '',
                    this.referenceNumberDamageServiceProvider ?
                        `AZ SD: ${this.referenceNumberDamageServiceProvider}` : '',
                ].filter(Boolean).join('<br>');
            },
            stateDataItems() {
                return this.state.attributes.stateDataItems || [];
            },
            hasCustomerDataForDisplay() {
                return this.customer.attributes.fullNameWithRepresentative
                    || this.customer.attributes.customerNumber;
            },
        },
        mounted() {
            const tabsElement = document.getElementById('tabs-content');

            if (tabsElement) {
                this.tabsContent = tabsElement.innerHTML;
                tabsElement.parentNode.removeChild(tabsElement);
            }
        },
        created() {
            this.loadBasedata();
        },
        methods: {
            handleReloadStateRecommended() {
                this.loadBasedata();
            },
            loadBasedata() {
                this.isLoading = true;
                recordRepository.getBasedata(this.recordId)
                    .then((data) => {
                        this.state = data.data.attributes.state.data;
                        this.vehicle = data.data.attributes.vehicle.data;
                        this.customer = data.data.attributes.customer.data;
                        this.firm = data.data.attributes.firm.data;
                        this.claimTypeLabel = data.data.attributes.claimTypeLabel;
                        this.referenceNumber = data.data.attributes.referenceNumber;
                        this.referenceNumberLawyer = data.data.attributes.referenceNumberLawyer;
                        this.referenceNumberDamageServiceProvider =
                            data.data.attributes.referenceNumberDamageServiceProvider;
                        this.permissions = data.data.meta.permissions;
                        this.isLoading = false;
                    });
            },
            reloadWindow() {
                window.location.reload();
            },
            async deleteRecord() {
                if (!confirm('Wollen Sie die Schadenakte wirklich löschen?')) {
                    return;
                }
                try {
                    await recordRepository.deleteRecord(this.recordId);
                    flashMessenger.addSuccess('Schadenakte wurde gelöscht.');
                    window.location.href = '/de/Schaden-Manager/Akte';
                } catch (e) {
                    console.error(e);
                    flashMessenger.addError('Löschen fehlgeschlagen.');
                }
            },
        },
    }
</script>
